<template>
  <v-card color="white" tile flat>
    <v-card-text>
      <v-chip>
        <SnippetUser v-if="measure.assignedTo" :currentUsers="measure.assignedTo" />
        <span v-else>Nicht zugewiesen</span>,
        <SnippetDate :items="measure.dueDate" />
      </v-chip>
      {{ measure.text }}
    </v-card-text>
  </v-card>
</template>

<script>
import SnippetUser from "@/components/snippets/SnippetUser.vue";
import SnippetDate from "@/components/snippets/SnippetDate.vue";

export default {
  props: {
    measure: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    SnippetUser,
    SnippetDate
  }
};
</script>
